var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-rule-builder',{attrs:{"fields":_vm.demoFields,"filter":_vm.filter}})}
var staticRenderFns = []

export { render, staticRenderFns }